module.exports = __webpack_public_path__ + "static/img/youjizz.41d5bc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/youjizz.png
// module id = 9EQo
// module chunks = 0